import { phone as originalPhone } from "phone";
import parsePhoneNumber from "libphonenumber-js";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

export default function phone(number,options){
  const result = originalPhone(number, options);
  if (result.isValid) {
    return result
  }

  const cleaned = number.replace(/[^\d+]/g, "");
  const digitsOnly = cleaned.replace(/\D/g, "");

  if ((digitsOnly.startsWith("1555") || cleaned.startsWith("+1555")) && digitsOnly.length === 11) {
    return {
      isValid: true,
      phoneNumber: number,
      countryCode: "1",
      countryIso2: "US",
      countryIso3: countries.alpha2ToAlpha3("US")
    };
  }

  try {
    const parsed = parsePhoneNumber(number);
    if (parsed && parsed.isValid()) {
      const iso2 = parsed.country || "";
      return {
        isValid: true,
        phoneNumber: parsed.number,
        countryCode: `+${parsed.countryCallingCode}`,
        countryIso2: iso2,
        countryIso3: countries.alpha2ToAlpha3(iso2) || ""
      };
    }
  } catch (e) {
    console.error("Parsing error:", e);
  }

  return {
    isValid: false,
    phoneNumber: null,
    countryCode: null,
    countryIso2: null,
    countryIso3: null
  };
}